import React, { useState, useEffect } from "react";
import * as DateTimeUtils from "../logic/DateTimeUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import { DateBox } from 'devextreme-react';

// Component styles
import classes from "./TimeWidget.module.scss";

const EMPTY = "EMPTY";

export function TimeWidget(props) {
  const { ui, data, config, writeBack, startWork } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let format = config && config.TimeFormat
    ? config.TimeFormat
    : DateTimeUtils.defaultGermanTimeFormat;
  let content = localContent !== EMPTY ? localContent : data && data.content ? new Date(DateTimeUtils.convertDotNetTicksToJSTicks(data.content)) : null;
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("TimeWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent(value);
    let ticks = (value && value !== EMPTY) ? DateTimeUtils.convertJSTicksToDotNetTicks(value.getTime()).toString() : null;
    writeBack(ticks, true);
  };

  return (
    <DateBox
      id={widgetId}
      className={cn(disabled ? classes.disabled : "")}
      type="time"
      value={content}
      displayFormat={format}
      onKeyUp={() => startWork()}
      onValueChanged={e => setContent(e.value)}
      disabled={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}
